module.exports = __webpack_public_path__ + "static/media/nov 2020.152c29aa.svg";